document.addEventListener('DOMContentLoaded', function () {
  var grid = document.getElementById('WishlistGrid');
  if (!grid) return;

  var emptyText = grid.dataset.emptyText;
  var items = (window.BrantaWishlist && window.BrantaWishlist.getItems()) || [];

  function showEmpty() {
    grid.innerHTML = '<p class="wishlist-page__empty">' + escapeHtml(emptyText) + '</p>';
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    return '₹' + amount.toLocaleString('en-IN', { maximumFractionDigits: 2 });
  }

  // Mirrors the "New" / "Buy 2 Get 1 Free" / "Flat X% Off" badge shown on
  // collection-page cards (snippets/card-product.liquid). Those cards cycle
  // through every matching badge via the global script in layout/theme.liquid,
  // but that script only scans the DOM once on page load, before these cards
  // exist - so here we just show the single highest-priority match instead
  // of wiring up the cycling behavior a second time.
  function buildBadge(product, discountPercentage) {
    var tags = (product.tags || []).map(function (tag) {
      return tag.toLowerCase();
    });
    var text = null;

    if (tags.indexOf('new') !== -1) {
      text = 'New';
    } else if (tags.indexOf('bogoo') !== -1) {
      text = 'Buy 2 Get 1 Free';
    } else if (discountPercentage > 0) {
      text = 'Flat ' + discountPercentage + '% Off';
    }

    if (!text) return '';

    return (
      '<div class="custom-badge-wrapper"><div class="custom-badge-container">' +
      '<span class="custom-badge active">' +
      escapeHtml(text) +
      '</span></div></div>'
    );
  }

  function addToCart(product, button) {
    var variant = product.variants && product.variants[0];
    if (!variant || typeof fetchConfig !== 'function' || !window.routes) return;

    var label = button.querySelector('span');
    var originalText = label.textContent;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    label.textContent = 'Adding…';

    var body = { id: variant.id, quantity: 1 };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    var config = fetchConfig('javascript');
    config.body = JSON.stringify(body);

    function reset(delay) {
      setTimeout(function () {
        label.textContent = originalText;
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
      }, delay);
    }

    fetch(window.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          label.textContent = response.description || 'Sold out';
          reset(2000);
          return;
        }

        if (cart) {
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
          if (typeof cart.renderContents === 'function') cart.renderContents(response);
          cart.classList.remove('is-empty');
        }

        label.textContent = 'Added!';
        reset(1500);
      })
      .catch(function () {
        reset(0);
      });
  }

  function buildCard(product, id) {
    var card = document.createElement('div');
    card.className = 'wishlist-card';

    var image = product.featured_image || (product.images && product.images[0]) || '';
    if (image && image.indexOf('?') === -1) image += '?width=600';

    var priceHtml = '<span class="wishlist-card__price-current">' + formatMoney(product.price) + '</span>';
    var discountPercentage = 0;
    if (product.compare_at_price && product.compare_at_price > product.price) {
      discountPercentage = Math.round(
        ((product.compare_at_price - product.price) * 100) / product.compare_at_price
      );
      priceHtml +=
        ' <s class="wishlist-card__price-compare">' + formatMoney(product.compare_at_price) + '</s>';
    }

    var variant = product.variants && product.variants[0];
    var available = variant && variant.available;

    card.innerHTML =
      buildBadge(product, discountPercentage) +
      '<a href="/products/' +
      product.handle +
      '" class="wishlist-card__media">' +
      '<img src="' +
      image +
      '" alt="' +
      escapeHtml(product.title) +
      '" loading="lazy" width="600" height="600">' +
      '</a>' +
      '<button type="button" class="wishlist-card__remove" aria-label="Remove from wishlist">' +
      '&times;' +
      '</button>' +
      '<div class="wishlist-card__info">' +
      '<a href="/products/' +
      product.handle +
      '" class="wishlist-card__title">' +
      escapeHtml(product.title) +
      '</a>' +
      '<div class="wishlist-card__price">' +
      priceHtml +
      '</div>' +
      '</div>' +
      '<button type="button" class="wishlist-card__add-to-cart quick-add__submit button button--full-width button--secondary"' +
      (available ? '' : ' aria-disabled="true"') +
      '><span>' +
      (available ? 'Add to cart' : 'Sold out') +
      '</span></button>';

    card
      .querySelector('.wishlist-card__remove')
      .addEventListener('click', function () {
        window.BrantaWishlist.remove(id);
        card.remove();
        if (!grid.querySelector('.wishlist-card')) showEmpty();
      });

    if (available) {
      card.querySelector('.wishlist-card__add-to-cart').addEventListener('click', function () {
        addToCart(product, this);
      });
    }

    return card;
  }

  if (!items.length) {
    showEmpty();
    return;
  }

  var fetches = items.map(function (item) {
    if (!item.handle) return Promise.resolve(null);
    return fetch('/products/' + item.handle + '.js')
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .catch(function () {
        return null;
      });
  });

  Promise.all(fetches).then(function (products) {
    grid.innerHTML = '';
    var rendered = 0;

    products.forEach(function (product, index) {
      if (!product) {
        // Blank handle (saved before this button stored one) or the product
        // no longer exists/fetch failed - either way it can never render, so
        // drop it instead of leaving a permanent ghost entry that keeps
        // inflating the header count without ever showing up here.
        window.BrantaWishlist.remove(items[index].id);
        return;
      }
      rendered++;
      grid.appendChild(buildCard(product, items[index].id));
    });

    if (!rendered) showEmpty();
  });
});
